<template>
    <div>
        <Table :columns="columns"
                :data="datalist"
                size="small"
                ref="tabledoc"
                border>
        </Table>
        <div class="text-right margin-top-10">
            <Button type="primary" @click="submit">确定</Button>
            <Button class="margin-left-10" @click="cancel">取消</Button>
        </div>
        <vLoading loading size="large" fix v-if="loading">正在测算费用，如sku数量多请耐心等待。。。</vLoading>
        <vLoading loading size="large" fix v-if="loading2"></vLoading>
    </div>
</template>

<script>
import { HttpGetCalculateList,HttpGetBuyLable } from '@/service/misc';
    export default {
        props:['orderid'],
        data(){
            return {
                rowId:-1,
                datalist:[],
                loading:false,
                loading2:false,
            }
        },
        created(){
            this.loading = true;
            HttpGetCalculateList({id:this.orderid}).then(res=>{
                this.datalist = res.data;
                this.loading = false;
            },err=>{
                this.loading = false;
                this.$Message.error({content:err.message,duration: 10,closable: true});
            })
        },
        computed:{
            columns(){
                return [
                    {
                        width: 60,
                        render: (h, { row, index }) => {
                            return h('Radio', {
                                props: {
                                    value: this.rowId === index
                                },
                                on: {
                                    input: (event) => {
                                        this.rowId = index;
                                    }
                                }
                            })
                        }
                    },
                    {
                        title: "发货方式",
                        key: "carrierServiceCode",
                    },
                    {
                        title: "预估费用",
                        key: "totalCustomerCost",
                    },
                    {
                        title: "币种",
                        key: "currency",
                    },
                ]
            }
        },
        methods:{
            submit(){
                if(this.rowId<0){
                    this.$Message.error('请选择发货方式！');
                    return;
                }
                // 选中之后请求购买面单的接口
                let newone = this.datalist.filter((item,index)=>{return index == this.rowId})[0];
                this.loading2 = true;
                HttpGetBuyLable({id:this.orderid,carrierServiceCode:newone.carrierServiceCode}).then(res=>{ 
                    this.loading2 = false;
                    this.$Message.success(res.message);
                    this.$emit('on-update');
                },err=>{
                    this.loading2 = false;
                    this.$Message.error({content:err.message,duration: 10,closable: true});
                })
            },
            cancel(){
                this.$emit('on-close');
            }
        }
    }
</script>